import React, { useMemo, useState } from "react";

import { splitEmailBody } from "./lib/emailBody";
import "./emailBody.css";

/**
 * One received email, rendered safely and without the chain repeated underneath.
 *
 * Every reply carries the whole prior conversation quoted below it, and a thread
 * view already shows those messages in their own right — so by default each one
 * was mostly a worse copy of the ones above. The quoted part is folded behind a
 * "•••" the way mail clients do it: available, not in the way.
 *
 * The HTML is sanitised before it reaches the DOM (see lib/emailBody). That is
 * not optional here — it is written by whoever emailed the clinic.
 */
export default function EmailBody({ html, preview }) {
  const [showQuoted, setShowQuoted] = useState(false);
  const { visible, quoted } = useMemo(() => splitEmailBody(html), [html]);

  // A message with no HTML body still has the plain-text preview Graph gives us.
  if (!visible && !quoted) {
    return preview ? <div className="emb-plain">{preview}</div> : null;
  }

  return (
    <div className="emb">
      <div className="emb-body" dangerouslySetInnerHTML={{ __html: visible }} />
      {quoted ? (
        <>
          <button
            type="button"
            className={"emb-toggle" + (showQuoted ? " is-open" : "")}
            onClick={() => setShowQuoted((v) => !v)}
            title={showQuoted ? "Hide the quoted conversation" : "Show the quoted conversation"}
            aria-expanded={showQuoted}
          >
            <span className="emb-dots">•••</span>
          </button>
          {showQuoted ? (
            <div className="emb-quoted" dangerouslySetInnerHTML={{ __html: quoted }} />
          ) : null}
        </>
      ) : null}
    </div>
  );
}
